import { WorkspaceProvider, useWorkspace } from "@/context/workspace-context";
import type { WorkspaceMode } from "@/context/workspace-context";
import { ChatSurface } from "@/components/workspace/chat-surface";
import { WorkflowsSurface } from "@/components/workspace/workflows-surface";
import { TasksSurface } from "@/components/workspace/tasks-surface";
import { OrgChart } from "@/pages/tenant/OrgChart";

function WorkspaceInner() {
  const { mode } = useWorkspace();

  return (
    <div className="flex h-full min-w-0 flex-col overflow-hidden">
      {/* Active surface. `code` (legacy Tasks) intentionally has no case —
          old deep-links gracefully fall through to the chat surface below. */}
      <div className="min-w-0 flex-1 overflow-hidden">
        {mode === "chat" && <ChatSurface />}
        {mode === "tasks" && <TasksSurface />}
        {mode === "org" && <OrgChart />}
        {mode === "workflows" && <WorkflowsSurface />}
        {mode === "code" && <ChatSurface />}
      </div>
    </div>
  );
}

export function Workspace({
  embedded = false,
  initialMode = "chat",
  initialThreadContext,
}: {
  embedded?: boolean;
  initialMode?: WorkspaceMode;
  initialThreadContext?: {
    agentId?: string;
    sessionId?: string;
    channelId?: string;
    issueId?: string;
  };
} = {}) {
  return (
    <WorkspaceProvider
      embedded={embedded}
      initialMode={initialMode}
      initialThreadContext={initialThreadContext}
    >
      <WorkspaceInner />
    </WorkspaceProvider>
  );
}
